import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  truckAuditData: [],
  loading: false,
  error: null,
  success: false,
  message: "",
};

export const dmsBucketSlice = createSlice({
  name: "dmsBucket",
  initialState,
  reducers: {
    initiateLoading: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.message = "";
    },
    fetchBucketListSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload || [];
      state.success = true;
      state.error = null;
    },
    fetchBucketListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.data = [];
    },
    manageBucketSuccess: (state, action) => {
      console.log("manage bucket success: ", action);
      state.loading = false;
      state.success = true;
      state.message = action.payload.message || "Operation successful";
      state.error = null;

      // If the response contains the updated bucket or list, update the state accordingly
      if (action.payload.updatedBucket) {
        // Find the index of the bucket being updated
        const index = state.data.findIndex(
          (bucket) => bucket.Id === action.payload.updatedBucket.Id,
        );
        if (index !== -1) {
          // Update the specific bucket if it exists in the list
          state.data[index] = action.payload.updatedBucket;
        }
      } else if (action.payload.refreshList) {
        // Optionally, fetch and update the list if it's required
        state.data = action.payload.updatedBuckets || state.data;
      }
    },
    manageBucketFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.message = "";
    },
    insertDMSTruckAuditSuccess: (state, action) => {
      state.loading = false;
      state.DMSTruckAuditData = action.payload || [];
      state.success = true;
      state.error = null;
    },
    insertDMSTruckAuditFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.DMSTruckAuditData = [];
    },
    clearDMSTruckAudit: (state, action) => {
      state.loading = false;
      state.DMSTruckAuditData = null;
      state.success = true;
      state.error = null;
    },
    getDMSTruckAuditByControlSuccess: (state, action) => {
      state.loading = false;
      state.truckAuditData = action.payload || [];
      state.success = true;
      state.error = null;
    },
    getDMSTruckAuditByControlFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.truckAuditData = [];
    },
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = "";
    },
    resetData: (state) => {
      return initialState;
    },
  },
});

export const {
  initiateLoading,
  fetchBucketListSuccess,
  fetchBucketListFailure,
  manageBucketSuccess,
  manageBucketFailure,
  resetState,
  resetData,
  insertDMSTruckAuditSuccess,
  insertDMSTruckAuditFailure,
  getDMSTruckAuditByControlSuccess,
  getDMSTruckAuditByControlFailure,
  clearDMSTruckAudit,
} = dmsBucketSlice.actions;

export const getDmsBucketSelector = (state) => state.dmsBucket;

export default dmsBucketSlice.reducer;
